import styled from "styled-components";
import { Row } from "react-bootstrap";

export const StyledAppointmentRow = styled(Row)`
   align-items: center;
   font-size: 14px;
`;
